import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import LoginForm from "./components/LoginForm";
import JoinOrganizationPage from "./components/JoinOrganizationPage";
import ForgotPasswordForm from "./components/ForgotPasswordForm";
import ResetPasswordForm from "./components/ResetPasswordForm";
import ChangePassword from "./components/ChangePassword";
import SuperAdminDashboard from "./components/SuperAdminDashboard";
import StudentDashboard from "./components/StudentDashboard";
import PerceptorDashboard from "./components/PerceptorDashboard";
import AdminDashboard from "./components/AdminDashboard";
import StandaloneAdminDashboard from "./components/standaloneAdminDashboard";
import SplashScreen from "./components/SplashScreen";
import AppErrorBoundary from "./components/AppErrorBoundary";
import PrivateRoute from "./components/PrivateRoute";
import GuestRoute from "./components/GuestRoute";
import { initializeTokenManager } from "./utils/tokenInitializer";
import { getDashboardViewPath } from "./utils/dashboardRoutes";

// "My Organization" used to be a top-level page that mounted its own navbar,
// which meant it rendered a navbar built from localStorage rather than the one
// the surrounding dashboard uses. It now lives as a view inside every dashboard;
// this keeps old links and bookmarks working by sending them to the right one.
const MyOrganizationRedirect = () => (
    <Navigate to={getDashboardViewPath('my-organization')} replace />
);

const AppRoutes = () => {
    const location = useLocation();

    return (
        <AppErrorBoundary resetKey={location.pathname}>
            <Routes>
                <Route path="/" element={<GuestRoute><LoginForm /></GuestRoute>} />
                <Route path="/join-organization" element={<JoinOrganizationPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordForm />} />
                <Route path="/reset-password" element={<ResetPasswordForm />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/my-organization" element={<PrivateRoute><MyOrganizationRedirect /></PrivateRoute>} />
                <Route path="/SuperAdminDashboard" element={<PrivateRoute><SuperAdminDashboard /></PrivateRoute>} />
                <Route path="/SuperAdminDashboard/:view" element={<PrivateRoute><SuperAdminDashboard /></PrivateRoute>} />
                <Route path="/StudentDashboard" element={<PrivateRoute><StudentDashboard /></PrivateRoute>} />
                <Route path="/StudentDashboard/:view" element={<PrivateRoute><StudentDashboard /></PrivateRoute>} />
                <Route path="/PreceptorDashboard" element={<PrivateRoute><PerceptorDashboard /></PrivateRoute>} />
                <Route path="/PreceptorDashboard/:view" element={<PrivateRoute><PerceptorDashboard /></PrivateRoute>} />
                <Route path="/AdminDashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
                <Route path="/AdminDashboard/:view" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
                <Route path="/StandaloneAdminDashboard" element={<PrivateRoute><StandaloneAdminDashboard /></PrivateRoute>} />
                <Route path="/StandaloneAdminDashboard/:view" element={<PrivateRoute><StandaloneAdminDashboard /></PrivateRoute>} />
            </Routes>
        </AppErrorBoundary>
    );
};

const App = () => {
    const [showSplash, setShowSplash] = useState(true);

    useEffect(() => {
        initializeTokenManager();
    }, []);

    if (showSplash) {
        return <SplashScreen onComplete={() => setShowSplash(false)} minDuration={2400} />;
    }

    return (
        <div className="app-container">
            <Router>
                <AppRoutes />
            </Router>
        </div>
    );
};

export default App;
